class CartItemPoints extends HTMLElement {
  static get observedAttributes() {
    return ['data-price', 'data-show-points', 'data-price-class'];
  }

  constructor() {
    super();

    this.isEnrolled = false;
    this.price = 0;
    this.showPoints = false;

    this.handleRewardsUpdated = this.handleRewardsUpdated.bind(this);
    this.handleRewardsInitialized = this.handleRewardsInitialized.bind(this);
  }

  connectedCallback() {
    this.initialize();
  }

  disconnectedCallback() {
    document.removeEventListener('aspen:rewards:updated', this.handleRewardsUpdated);
    document.removeEventListener('aspen:rewards:initialized', this.handleRewardsInitialized);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) {
      return;
    }

    if (name === 'data-price') {
      this.price = parseFloat(newValue) || 0;

      if (this.isConnected) {
        this.render();
      }
    } else if (name === 'data-show-points') {
      this.showPoints = newValue === 'true';

      if (this.isConnected) {
        this.render();
      }
    }
  }

  initialize() {
    this.isEnrolled = this.querySelector('.points-price') !== null;

    if (!this.isEnrolled) {
      this.style.display = 'none';
    }

    const priceAttr = this.getAttribute('data-price');
    const showPointsAttr = this.getAttribute('data-show-points');

    if (priceAttr) {
      this.price = parseFloat(priceAttr) || 0;
    }

    if (showPointsAttr === 'true') {
      this.showPoints = true;
    }

    document.addEventListener('aspen:rewards:updated', this.handleRewardsUpdated);
    document.addEventListener('aspen:rewards:initialized', this.handleRewardsInitialized);

    if (window.AspenRewards) {
      const state = window.AspenRewards.getState();
      this.updateFromState(state);
    } else {
      const checkAspenRewards = () => {
        if (window.AspenRewards) {
          const state = window.AspenRewards.getState();
          this.updateFromState(state);
        } else {
          setTimeout(checkAspenRewards, 50);
        }
      };

      checkAspenRewards();
    }
  }

  updateFromState(state) {
    if (state.isEnrolled === this.isEnrolled) {
      return;
    }

    this.isEnrolled = state.isEnrolled;
    this.render();
  }

  handleRewardsInitialized(event) {
    this.updateFromState(event.detail);
  }

  handleRewardsUpdated(event) {
    this.updateFromState(event.detail);
  }

  calculatePoints() {
    if (this.price <= 0) {
      return 0;
    }

    return Math.round(this.price);
  }

  formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  render() {
    if (!this.showPoints || !this.isEnrolled) {
      this.innerHTML = '';
      this.style.display = 'none';

      return;
    }

    const points = this.calculatePoints();
    const priceClass = this.getAttribute('data-price-class') || '';

    this.innerHTML = `
      <p class='points-price ${priceClass}'>
        (+
        ${this.formatNumber(points)}
        points)
      </p>
    `;

    this.style.display = '';
  }
}

if (!customElements.get('cart-item-points')) {
  customElements.define('cart-item-points', CartItemPoints);
}
